module.exports = __webpack_public_path__ + "img/header-bg-img-hospitality.85f2d49c.png";